import { useEffect, useState } from 'react'
import { useFormikContext } from 'formik'

import { getEmailAccountFont } from '../../../Email.api'
import { EMAIL_CREATION_FORM_FIELD_NAME_FROM } from '../../EmailCreationForm.constants'

export function useFont() {
  const [font, setFont] = useState(null)

  const { values } = useFormikContext()

  const accountId = values[EMAIL_CREATION_FORM_FIELD_NAME_FROM]?.value

  useEffect(() => {
    if (accountId) {
      getEmailAccountFont(accountId).then(({ data }) => {
        setFont({ ...data.font, size: data.size.size })
      })
    }
  }, [accountId])

  return { font }
}
